import { logger } from "src/core";

const DEVICE_ID_FORMAT = /^([a-f0-9]{2}-){5}([a-f0-9]{2})$/i;
const IS_DEAD = /^de-ad-([a-f0-9]{2}-?){4}$/i;

export const isValidDeviceId = (
  deviceId: string,
  skipLogging = false
): boolean => {
  if (!DEVICE_ID_FORMAT.test(deviceId)) {
    if (!skipLogging) {
      logger.trace("Device id has wrong format");
    }
    return false;
  }
  if (IS_DEAD.test(deviceId)) {
    if (!skipLogging) {
      logger.info(`Device id ${deviceId} is a temp id`);
    }
    return false;
  }
  return true;
};
